import Vue from 'vue'
import L from 'leaflet'
import '@geoman-io/leaflet-geoman-free'
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css'

export const MAP_UPDATE = 'MAP_UPDATE'
export const DEFAULT_ZOOM = 19
export const DEFAULT_MAP_OPTIONS = {
  maxZoom: 23,
  minZoom: 17,
  maxBounds: [
    [-0.01, -0.01],
    [1, 1]
  ],
  options: {
    attributionControl: false
  }
}

const PROPS_TO_NUMBER = ['floorId', 'activePointId']

function tryConvertToInt(value) {
  const converted = parseInt(value)
  return Number.isNaN(converted) ? value : converted
}

export default {
  namespaced: true,
  state: {
    map: null,
    activePointId: null,
    floorId: null,
    printMode: false,
    displayTooltips: false,
    editMode: false
  },
  mutations: {
    [MAP_UPDATE](state, payload) {
      Object.entries(payload).forEach(([name, value]) => {
        if (PROPS_TO_NUMBER.includes(name)) {
          value = tryConvertToInt(value)
        }
        Vue.set(state, name, value)
      })
    }
  },
  actions: {
    setDefaultCenter({ state, dispatch }) {
      let center = state.map.getBounds().getCenter()
      let centerPoint = state.map.latLngToLayerPoint(center)
      centerPoint = centerPoint.add(new L.Point(100, -100)) // add some offset
      center = state.map.layerPointToLatLng(centerPoint)
      dispatch('setCenter', { center, zoom: DEFAULT_ZOOM })
    },
    setCenter({ state }, { center, animate = false, zoom = null }) {
      zoom = zoom ?? state.map.getZoom()
      state.map.setView(center, zoom, { animate })
    },
    resetZoom({ state }) {
      state.map.setZoom(DEFAULT_ZOOM)
    }
  }
}
